import { pmiClient } from './pmiApi';

const root = '/work-tasks';
const idPath = id => `${root}/${encodeURIComponent(id)}`;
const taskResult = response => response.data.task || response.data;
const workTasksApi = {
  capabilities: async () => (await pmiClient.get(`${root}/capabilities`)).data,
  legacy: async (source, apply = false) => (await pmiClient.post(`${root}/legacy`, { source, apply })).data,
  list: async (params, signal) => (await pmiClient.get(root, { params, signal })).data,
  get: async id => (await pmiClient.get(idPath(id))).data,
  create: async body => taskResult(await pmiClient.post(root, body)),
  update: async (id, body) => taskResult(await pmiClient.patch(idPath(id), body)),
  staff: async sources => (await pmiClient.post(`${root}/staff`, { sources })).data,
  link: async (id, body) => taskResult(await pmiClient.post(`${idPath(id)}/sources`, body)),
  unlink: async (id, body) => taskResult(await pmiClient.post(`${idPath(id)}/sources/remove`, body)),
  events: async (id, page = 1) => (await pmiClient.get(`${idPath(id)}/events`, { params: { page, page_size: 30 } })).data,
  comment: async (id, body) => taskResult(await pmiClient.post(`${idPath(id)}/comments`, body)),
  notices: async () => (await pmiClient.get(`${root}/notices`)).data,
  readNotice: async id => (await pmiClient.patch(`${root}/notices/${encodeURIComponent(id)}`)).data,
};
export default workTasksApi;
